import { Action, ActionType } from "@redux/actionTypes/beRLDCostActionTypes";
import { Reducer } from "redux";

export interface IBeRLDCostState {
  BeRLDProjectDetailsCostByID: IBERLDCostProjectDetails[];
}

export interface IBERLDCostProjectDetails {
  projectId: number;
  projectName: string;
  rldCostTable: IRLDCost;
  pilotBETable: IPilotBE;
  pivotalBETable: IPivotalBE;
}
interface IRLDCost {
  headers?: Iheaders[];
  tableData: Record<string, any>[];
  totalObject?: Record<string, any>[];
}
interface IPilotBE {
  headers?: Iheaders[];
  tableData: Record<string, any>[];
  totalObject?: Record<string, any>[];
}
interface IPivotalBE {
  headers?: Iheaders[];
  tableData: Record<string, any>[];
  totalObject?: Record<string, any>[];
}
export interface Iheaders {
  headName: string;
  value: string;
  classname?: string;
}

const initialState = {
  BeRLDProjectDetailsCostByID: [],
};

export const beRLDCostRducer: Reducer<IBeRLDCostState, Action> = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.BE_RLD_COST_UPDATE:
      return {
        ...state,
        BeRLDProjectDetailsCostByID: action.payload,
      };
    case ActionType.RESET_REDUX_STATE:
      return initialState;

    default:
      return state;
  }
};
